<template>
  <div>
    <template v-if="checkObject(items)">
      <v-list dense>
        <template v-for="(item, index) in items">
          <v-list-item :key="index" @click="doClick(item.params)" v-if="!item.hidden">
            <v-list-item-action>
              <v-icon :color="item.iconColor" v-if="item.icon">{{ item.icon }}</v-icon>
              <v-icon :color="primary" v-else>mdi-folder</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </template>
    <template v-else>
      <loader :height="200" :loading="true"></loader>
    </template>
  </div>
</template>

<script>
import routeMixin from '@/mixins/route'
import { isEmptyOrWhiteSpace } from '@/utils'
export default {
  data() {
    return {
      hover: false
    }
  },
  methods: {
    checkObject(obj) {
      return !isEmptyOrWhiteSpace(obj)
    },
    doClick(params) {
      if (this.checkObject(params)) {
        this.$emit('doClick', params)
      } else {
        this.$emit('doClick', undefined)
      }
    }
  },
  props: {
    items: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  mixins: [routeMixin]
}
</script>

<style scoped>
</style>
